// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1yDRn","buttons":"Footer_buttons__Gq2PA"};